import { z } from 'zod';

/**
 * How long a recording may be kept: a fixed list, not any number of days (owner, 19 September
 * 2026: recordings live in S3 and "use a life cycle on the files").
 *
 * S3 expires objects by lifecycle rules, one per retention length, matched on the object's
 * `arc-retention` tag. A fixed list keeps the rule set small and identical everywhere; the bucket
 * is configured from this list (tools/configure-recordings.mjs --lifecycle). Null keeps them.
 */
export const RETENTION_DAYS = [30, 60, 90, 180, 365, 730, 1095, 1825, 2555, 3650] as const;
export type RetentionDays = (typeof RETENTION_DAYS)[number];

export const RetentionDaysSchema = z.number().int()
  .refine((d) => (RETENTION_DAYS as readonly number[]).includes(d), {
    message: `Retention is one of ${RETENTION_DAYS.join(', ')} days`,
  });

/** The object tag that selects a lifecycle rule. */
export const RETENTION_TAG = 'arc-retention';
export const retentionTagValue = (days: number | null): string => (days === null ? 'keep' : `${days}d`);

/** How the portal names a length: "30 days", "1 year", "5 years". */
export function retentionLabel(days: number): string {
  if (days % 365 === 0) {
    const y = days / 365;
    return y === 1 ? '1 year' : `${y} years`;
  }
  return `${days} days`;
}
